import { render, staticRenderFns } from "./ModalLink.vue?vue&type=template&id=2e8f149c&scoped=true&"
import script from "./ModalLink.vue?vue&type=script&lang=js&"
export * from "./ModalLink.vue?vue&type=script&lang=js&"
import style0 from "./ModalLink.vue?vue&type=style&index=0&id=2e8f149c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e8f149c",
  null
  
)

export default component.exports